import { Stack } from '@mantine/core'
import classes from './Demo.module.css'
import Header from '../common/components/header/Header'
import Meta from '../common/Meta'
import { Page } from './Page'
import Widget from './Widget'
import { useCompetitionId } from '../common/hooks'

export default function MetricDemo() {
  const competition_id = useCompetitionId()

  return (
    <Page
      path="/demo"
      context={{
        subject_type: 'user',
        subject: 2,
        competition_id: competition_id,
      }}
    >
      <div className={classes.container}>
        <Meta title="Metrics test" />
        <Header title="Metrics" />
        <Stack pt={20}>
          <h1>Player: James Williams</h1>
          <Widget id="root" />
        </Stack>
      </div>
    </Page>
  )
}
